var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBinanceLogo = function SvgBinanceLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.78108 5.88294L7.49987 3.16421L10.2201 5.88434L11.8021 4.30234L7.49987 0L3.19915 4.30094L4.78108 5.88294ZM0.5 6.99978L2.08204 5.41773L3.66398 6.99969L2.08195 8.58172L0.5 6.99978ZM4.78108 8.11706L7.49987 10.8358L10.22 8.11573L11.8028 9.69689L11.8021 9.69773L7.49987 14L3.19901 9.6992L3.19677 9.69696L4.78108 8.11706ZM11.336 7.00065L12.9181 5.41861L14.5 7.00055L12.918 8.5826L11.336 7.00065Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90028 6.99937H8.90089L7.50156 5.6001L6.46743 6.63419H6.46737L6.34856 6.75305L6.10352 6.99815L6.10156 7.00004L6.10352 7.00205L7.50156 8.4001L8.90089 7.00083L8.90156 7.00004L8.90028 6.99937",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBinanceLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/binance-logo.2270cbeef5d689323161207674ff6ab2.svg";